import { useQuery } from "@tanstack/react-query";
import { authFetch } from "@/lib/authFetch";

export interface AlternanceJour {
  technician_id: string;
  date: string;
  statut: string;
  source?: string;
}

/**
 * Charge tous les jours d'alternance (table alternance_jours).
 * Retourne un Map<"techId_YYYY-MM-DD", statut> pour lookup O(1).
 * Plage optionnelle : from / to au format YYYY-MM-DD.
 */
export function useAlternanceJours(from?: string, to?: string) {
  const params = new URLSearchParams();
  if (from) params.set("from", from);
  if (to) params.set("to", to);
  const qs = params.toString();

  const { data } = useQuery<AlternanceJour[]>({
    queryKey: ["/api/alternance", from ?? "", to ?? ""],
    queryFn: async () => {
      const res = await authFetch(`/api/alternance${qs ? "?" + qs : ""}`);
      if (!res.ok) throw new Error("Erreur chargement alternance");
      return res.json();
    },
    staleTime: 5 * 60 * 1000,
  });

  const map = new Map<string, string>();
  if (data) {
    for (const row of data) {
      map.set(`${row.technician_id}_${row.date}`, row.statut);
    }
  }
  return map;
}
